import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/unknown_error.svg'


const _hoisted_1 = {
  class: "container",
  role: "main",
  "aria-label": "Unknown Error Page"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col text-center" }, [
    /*#__PURE__*/_createElementVNode("figure", null, [
      /*#__PURE__*/_createCommentVNode(" Image downloaded from ShutterStock and color changed by Marketing dept "),
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        class: "w-50 p-3",
        alt: "Unknown Error Image"
      })
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h1 class=\"mb-2\">Oops!</h1><h4 class=\"mb-3\">Something went wrong...</h4><p class=\"text-secondary mb-0\"> If the situation persists, </p><p class=\"text-secondary mb-0\"> please submit an IT Help Desk request <a href=\"https://nationalautocare.atlassian.net/servicedesk/customer/portal/4/group/9/create/23\" class=\"btn-link\" aria-label=\"\">here</a>. </p><p class=\"text-secondary mb-0\"> We apologize for any inconvenience. </p>", 5)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", { class: "row" }, [
      _createElementVNode("div", { class: "col text-center" }, [
        _hoisted_3,
        _createElementVNode("div", { class: "mt-3" }, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            title: "Home Button",
            onClick: $setup.handleBackToHome,
            "aria-label": "Back to Home"
          }, " Back to Home ")
        ])
      ])
    ])
  ]))
}